import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import {
    listPermissions, getPermissionsByRole, addPermissionToRole, deletePermissionToRole, fetchPermissionByUser, deletePermission
} from '../../services/auth'


@Module({
    namespaced: true,
})


export default class Role extends VuexModule {

    // state 
    permissionList = [];
    permissionsByRole = [];
    userPermissionList = [];

    // actions
    @Action
    public async fetchAllPermission() {
        try {
            const data = await listPermissions();
            this.context.commit('setPermissionList', data.response);
            return data
        } catch (error) {
            throw error
        }
    }


    @Action
    public async fetchPermissionsByUser(payload) {
        try {
            const data = await fetchPermissionByUser(payload);
            this.context.commit('setUserPermissions', data.response);
            return data
        } catch (error) {
            throw error
        }
    }

    @Action
    public async getPermissionsByRole(payload) {
        try {
            const data = await getPermissionsByRole(payload);
            this.context.commit('setPermissionByRole', data.response);
            return data
        } catch (error) {
            throw error
        }
    }

    @Action
    public async addPermissionToRole(payload) {
        try {
            const data = await addPermissionToRole(payload.role, payload.permission);
            return data
        } catch (error) {
            throw error
        }
    }

    @Action
    public async removePermission(payload) {
        try {
            const data = await deletePermission(payload);
            return data
        } catch (error) {
            throw error
        }
    }

    @Action
    public async removePermissionToRole(payload) {
        try {
            const data = await deletePermissionToRole(payload);
            return data
        } catch (error) {
            throw error
        }
    }



    // mutations 
    @Mutation
    public setPermissionList(data: any) {
        this.permissionList = data;
    }

    @Mutation
    public setUserPermissions(data: any) {
        this.userPermissionList = data;
    }

    @Mutation
    public setPermissionByRole(data: any) {
        this.permissionsByRole = data;
    }

    // getters
    get GetAllPermissionList() {
        return this.permissionList;
    }

    get GetPermissionListByRole() {
        return this.permissionsByRole;
    }

    get GetUserPermissions() {
        return this.userPermissionList;
    }

}